import { Injectable, signal } from '@angular/core';
import { Term } from 'src/app/features/business-glossary-management/models/business-glossary.models';

@Injectable({
  providedIn: 'root',
})
export class BusinessTermDrawerService {
  // Drawer state
  private _isOpen = signal<boolean>(false);
  private _termId = signal<string | null>(null);
  private _termData = signal<Term | null>(null);
  private _isLoading = signal<boolean>(false);
  private _error = signal<string | null>(null);

  // Public readonly signals
  public readonly isOpen = this._isOpen.asReadonly();
  public readonly termId = this._termId.asReadonly();
  public readonly termData = this._termData.asReadonly();
  public readonly isLoading = this._isLoading.asReadonly();
  public readonly error = this._error.asReadonly();

  /**
   * Open drawer with business term ID
   */
  open(id: string): void {
    this._termId.set(id);
    this._isOpen.set(true);
    this._isLoading.set(true);
    this._error.set(null);
  }

  /**
   * Close drawer and reset state
   */
  close(): void {
    this._isOpen.set(false);
    // Delay reset to allow close animation
    setTimeout(() => {
      this._termId.set(null);
      this._termData.set(null);
      this._isLoading.set(false);
      this._error.set(null);
    }, 300);
  }

  /**
   * Set business term data (called by component after fetching)
   */
  setTermData(termData: Term | null): void {
    this._termData.set(termData);
    this._isLoading.set(false);
  }

  /**
   * Set loading state
   */
  setLoading(loading: boolean): void {
    this._isLoading.set(loading);
  }

  /**
   * Set error state
   */
  setError(error: string | null): void {
    this._error.set(error);
    this._isLoading.set(false);
  }
}
